(function () {
  var toggle = document.getElementById('FNavToggle');
  var panel = document.getElementById('FNavPanel');
  var backdrop = document.getElementById('FNavBackdrop');
  var closeBtn = document.getElementById('FNavClose');
  if (!toggle || !panel || !backdrop) return;

  function setOpen(open) {
    toggle.classList.toggle('is-open', open);
    panel.classList.toggle('is-open', open);
    backdrop.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }

  function closeCartDrawer() {
    var cartDrawer = document.getElementById('FCartDrawer');
    var cartBackdrop = document.getElementById('FCartBackdrop');
    var cartToggle = document.getElementById('FCartToggle');
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartBackdrop) cartBackdrop.classList.remove('is-open');
    if (cartToggle) cartToggle.setAttribute('aria-expanded', 'false');
  }

  toggle.addEventListener('click', function () {
    var opening = !panel.classList.contains('is-open');
    if (opening) closeCartDrawer();
    setOpen(opening);
  });
  backdrop.addEventListener('click', function () { setOpen(false); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });

  panel.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', function () { setOpen(false); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setOpen(false);
  });

  document.querySelectorAll('[data-nav-toggle]').forEach(function (navToggle) {
    var list = navToggle.parentElement.querySelector('[data-nav-sublist]');
    if (!list) return;
    navToggle.addEventListener('click', function () {
      var expanded = !list.hidden;
      list.hidden = expanded;
      navToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });
  });
})();
